<template>
  <div v-show="show" ref="Box" class="bgI">
    <!--<topHead />-->
    <div class="head-contents-txz">
      <div class="nav-txz">
        <div class="logo">
          <a href="/home"><img :src="logo_txz"></a>
        </div>
        <div class="nav">
          <a href="http://www.pengzushijia.com/" target="_blank">平台导航</a>
          <a href="http://maker.pengzushijia.com/" target="_blank">编纂平台</a>
          <a href="http://maker.pengzushijia.com/project/allDataBase" target="_blank">总数据库</a>
          <!--<a href="http://admin.pengzushijia.com" target="_blank">管理平台</a>-->
          <a href="/home" style="color: #000000;">彭祖世家网首页</a>
        </div>
      </div>
    </div>
    <div class="loginBgBox">
      <img :src="loginIMG" alt="">
    </div>
    <div v-if="!isForgotPwd" class="contentBox">
      <div class="contentBox_leftBox">
        <img :src="zgoModImg" alt="">
        <p style="font-size: 16px;color: #666">
          扫一扫，访问彭祖世家网手机版
        </p>
      </div>
      <div class="contentBox_rightBox">
        <div class="topname">
          <span>通行证登录</span>
          <span class="registerbtn" @click="goregisted">注册</span>
        </div>
        <el-form ref="ruleForm" :model="ruleForm" status-icon :rules="rules" label-width="100px" class="demo-ruleForm">
          <el-form-item prop="phoneNumber" style="margin-bottom: 40px">
            <el-input v-model="ruleForm.phoneNumber" auto-complete="off" placeholder="请输入手机号或账号登录">
              <!--<i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="user" /></i>-->
            </el-input>
          </el-form-item>
          <!--<el-form-item prop="checkCode">-->
          <!--<el-input v-model="ruleForm.checkCode" type="checkCode" placeholder="请确验证码 " class="checkbox">-->
          <!--&lt;!&ndash;<i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="pwd" /></i>&ndash;&gt;-->
          <!--</el-input>-->
          <!--<div v-show="isVcodeBtn" class="getVcodeBtn" @click="getVcode">-->
          <!--获取验证码-->
          <!--</div>-->
          <!--<div v-show="!isVcodeBtn" class="getVcodeBtn num">-->
          <!--重新发送 <span>({{ count }})</span>-->
          <!--</div>-->
          <!--</el-form-item>-->
          <el-form-item prop="password" :error="modelerror">
            <el-input v-model.number="ruleForm.password" type="password" placeholder="请输入密码 ">
              <!--<i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="pwd" /></i>-->
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="denglubtn" @click="submitForm('ruleForm')">
              登录
            </el-button>
            <!--<el-button @click="resetForm('ruleForm')">-->
            <!--重置-->
            <!--</el-button>-->
          </el-form-item>
        </el-form>
        <!--<div class="forgotpwd" @click="changeContent">-->
        <!--忘记密码?-->
        <!--</div>-->
        <!--<div class="register">-->
        <!--还没账号？<span @click="goregisted">立即注册</span>-->
        <!--</div>-->
        <div class="wxlogin">
          <a :href="wxurl"><span class="wxlogo"><svg-icon icon-class="wx" /></span><span>微信登录</span></a>
          <!--<div>-->
          <!--<p @click="handelWxLogin">-->
          <!--<a :href="wxurl"></a>-->
          <!--</p>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <forGotPwd v-show="isForgotPwd" />
    <el-dialog
      title="绑定微信"
      :visible.sync="bindWxFlag"
      width="35%"
      :before-close="handleClose"
      :close-on-click-modal="handelmodal"
    >
      <p>为了提供更好的用户体验，您的账号需要绑定微信才可以继续使用，去绑定吗？</p>
      <div style="text-align: right;margin-top: 20px">
        <a href="/home" class="dialog_btn">暂不登录</a>
        <span class="dialog_btn dialog_btn_new" @click="bindWx">绑定微信</span>
      </div>
    </el-dialog>
    <div class="foo_tips">
      <div>©2019彭祖世家网·《彭祖世家总谱·事典》总谱官网及门户网站 Pengzushijia.COM 彭祖世家文化发展有限公司 <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #9EA0A3;">粤ICP备19063974号</a> 技术支持：武汉聚脉网络科技有限公司</div>
      <!--<div>GB/T29490-2013知识产权管理体系认证证书编号：165IP194386ROS     联系邮箱：contactus@jointat.com</div>-->
    </div>
  </div>
</template>
<script>
import { cheakLogin, checkRegister, getVcode, getUserPhoneRegisterUrl } from '@/api/api.js'
import { getWxLoginUrl, addWeiXinUserUrl } from '@/api/login.js'
import forGotPwd from '@/components/forgotpassword/index.vue'
import { ssoUserLogin } from '@/api/api.js'
// import topHead from '@/views/components/header.vue'
export default {
  components: { forGotPwd },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '登录-彭祖世家网Pengzushijia.com',
      mateDesc: '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，系彭祖世家文化发展有限公司与武汉聚脉网络科技有限公司合作，基于聚脉网络旗下国家发明专利技术产品“大谱师-互联网家谱协作编纂平台”进行品牌定制，专属服务全球彭氏族群编纂《彭祖世家总谱-事典》总谱、家族谱、家庭谱的互联网家谱协作编纂平台。',
      keys: '族谱,家族,编谱,族谱查询,族谱app,族谱在线制作,寻根问祖,百家姓,姓氏源流'
    }
  },
  data() {
    var checkpass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var checkvcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入账号'))
      } else {
        callback()
      }
      setTimeout(() => {
        if (!(/^1[345789]\d{9}$/.test(value))) {
          callback(new Error('格式错误，请输入正确的手机号'))
        } else {
          callback()
        }
      }, 500)
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value + '' !== this.ruleForm.password + '') {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      fmsCode: require('@/static/familyspaceCode.png'),
      puyueCode: require('@/static/readerCode.png'),
      modelerror: '',
      handelmodal: false,
      bindWxFlag: false,
      zgoModImg: require('@/static/pengcode.png'),
      logo_txz: require('@/static/cmslogo.png'),
      wxurl: '',
      loginIMG: require('@/static/bg_txz.png'),
      show: false,
      isForgotPwd: false,
      isVcodeBtn: true,
      count: 60,
      ruleForm: {
        phoneNumber: '',
        checkCode: '',
        password: ''
      },
      rules: {
        phoneNumber: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        password: [
          { validator: checkpass, trigger: 'blur' }
        ],
        checkCode: [
          { validator: checkvcode, trigger: 'blur' }
        ]
      }
    }
  },
  inject: ['reload'],
  mounted() {
    this.handelWxLogin()
    // var h = document.documentElement.clientHeight || document.body.clientHeight
    // var h = window.outerHeight
    // this.$refs.Box.style.height = h - 391 + 'px'
    const that = this
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which
      if (keycode == 13) {
        that.submitForm('ruleForm')
        return false
      }
    }
    this.show = true
    var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
    if (is_mobi) {

    } else {
      this.$emit('footshow', 8)
    }
    ssoUserLogin().then(res => {
      if (res.data.userId) {
        this.setloca('userid', res.data.userId, 7200)
        localStorage.removeItem('unionid')
        this.$router.go(-1)
      }
    })
  },
  methods: {
    submitForm(formName) { // //登录验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = {}
          obj.userName = this.ruleForm.phoneNumber
          obj.passWord = this.ruleForm.password
          cheakLogin(obj).then(res => {
            if (res.code === 200) {
              if (res.data.isBding) {
                this.setloca('username', this.ruleForm.phoneNumber, 7200)
                this.setloca('userid', res.data.fwUserId, 7200)
                this.setloca('readerUsrId', res.data.readerUsrId, 7200)
                if (this.getLoca('isback')) {
                  window.open(this.getLoca('isback'))
                } else {
                  var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
                  if (is_mobi) {
                    this.$router.push('/home')
                  } else {
                    this.$router.push('/user?index=0')
                  }
                }
              } else {
                this.bindWxFlag = true
              }
            } else if (res.code == 425) {
              this.modelerror = '密码错误'
              // ////手动报错，密码错误
              // this.rules.password[0].validator = (rule, value, callback) => {
              //   callback(new Error('密码错误'))
              // }
            }
          })
          // checkRegister(obj).then(res => {
          //   if (res.data.code == 0) {
          //     this.setloca('username', this.ruleForm.phoneNumber, 7200)
          //     this.setloca('userid', res.data.fwUserId, 7200)
          //     this.setloca('readerUsrId', res.data.readerUsrId, 7200)
          //     this.$router.go(-1)
          //     this.$router.push({ path: '/home' })
          //   }
          //   if (res.data.code == 1) {
          //     this.setloca('loginphone', res.data.phone, 7200)
          //     var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
          //     if (is_mobi) {
          //       getUserPhoneRegisterUrl({ loginType: 'app' }).then(res => {
          //         window.open(res.data.url)
          //       })
          //     } else {
          //       getUserPhoneRegisterUrl().then(res => {
          //         window.open(res.data.url)
          //       })
          //     }
          //   }
          //   if (res.data.code == 2 || res.data.code == 3) {
          //     this.$message({
          //       showClose: true,
          //       message: res.data.msg,
          //       type: 'warning'
          //     })
          //   }
          // })
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    goregisted() { // 去注册
      this.$router.replace({ path: '/register' })
    },
    changeContent() { // /忘记密码
      this.isForgotPwd = true
    },
    gologin() { // //去登录
      this.isForgotPwd = false
    },
    handelWxLogin() {
      var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
      if (is_mobi) {
        getWxLoginUrl({ loginType: 'app' }).then(res => {
          this.wxurl = res.data.url
        })
      } else {
        getWxLoginUrl().then(res => {
          this.wxurl = res.data.url
        })
      }
    },
    bindWx() {
      var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
      if (is_mobi) {
        addWeiXinUserUrl({ loginType: 'app' }).then(res => {
          window.open(res.data.url)
        })
      } else {
        addWeiXinUserUrl().then(res => {
          window.open(res.data.url)
        })
      }
    },
    handleClose() {
      this.bindWxFlag = false
    },
    getVcode() {
      this.ruleForm.checkCode = ''
      if (!(/^1[34578]\d{9}$/.test(this.ruleForm.phoneNumber))) {
        this.$message({
          message: '请正确输入手机号',
          type: 'error',
          duration: 2000
        })
      } else {
        var obj = {}
        obj.phone = this.ruleForm.phoneNumber
        obj.codeType = '1'
        this.isVcodeBtn = false
        var timers = setInterval(() => {
          this.count--
          if (this.count <= 0) {
            this.isVcodeBtn = true
            clearInterval(timers)
          }
        }, 1000)
        getVcode(obj).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '短信验证已发送',
              type: 'success',
              duration: 2000
            })
          }
        })
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .puyue{
    position: relative
  }
  .fms{
    position: relative;
  }
  .bgI .puyueCode{
    width: 179px;
    /*height: 213px;*/
    position: absolute;
    top: 32px;
    left: -63px;
    z-index: 99;
    transition: 0.3s;
    height: 0;
  }
  .puyue:hover >.puyueCode{
    height: 213px;
  }
  .bgI .fmsCode{
    width: 179px;
    /*height: 213px;*/
    position: absolute;
    top: 32px;
    left: -41px;
    z-index: 99;
    transition: 0.3s;
    height: 0;
  }
  .fms:hover >.fmsCode{
    height: 213px;
  }
  .dialog_btn{
    display: inline-block;
    width: 130px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    border: 1px solid #E6E6E6;
    color: #ccc;
  }
  .dialog_btn_new{
    background-color: #FF7214;
    color: #ffffff;
    border: 1px solid #FF7214;
    margin-left: 20px;
    cursor: pointer;
  }
       .bgI{
           width: 100%;
           min-height: 100vh;
           position: relative;
           overflow: hidden;
           img{
               width: 100%;
           }
           .loginBgBox{
             position: absolute;
             width: 100%;
             height: 615px;
             overflow: hidden;
             z-index: -1;
           }
           .contentBox{
               margin: 210px auto 80px;
               height: 415px;
               width: 800px;
               padding-top: 35px;
               background-color: #fff;
               border-left: 1px solid #f0f0f0;
               border-right: 1px solid #f0f0f0;
               border-bottom: 1px solid #f0f0f0;
               -moz-box-shadow:1px 1px 3px #f3f3f3;
               -webkit-box-shadow:1px 1px 3px #f3f3f3;
               box-shadow:1px 1px 3px #f3f3f3;
             overflow: hidden;
               .topname{
                   margin: 40px auto;
                    margin-top: 0;
                   /*margin-top: 20px;*/
                   overflow: hidden;
                   text-align: center;
                   .registerbtn{
                        border: none;
                       cursor: pointer;
                   }
                   span{
                       display: inline-block;
                       width: 100px;
                       height: 50px;
                       font-size: 17px;
                       line-height: 50px;
                       margin-left: 10px;
                       border-bottom: 2px solid #ed4040;
                   }
               }

           }
       }
   .ico{
       height: 40px;
       width: 30px;
       color: #69513c;
   }
    .denglubtn{
      margin-top: 40px;
      width: 320px;
      margin-left: 23px;
      background-color: #7E6B5A;
      border-color: #7E6B5A;
    }
    .forgotpwd{
        color: #808080;
        text-align: center;
        font-size: 12px;
        cursor: pointer;
        &:hover{
            color: #ed4040;
        }
    }
    .register{
        text-align: center;
        font-size: 12px;
        color: #808080;
        margin-top: 15px;
        span{
            font-size: 12px;
            color: #ed4040;
            cursor: pointer;
        }
    }
    .wxlogin{
        text-align: center;
        margin-top: 30px;
      a{
        display: inline-block;
        overflow: hidden;
      }
      span{
        font-size: 12px;
        color: #BCBCBC;
        margin-left: 10px;
      }
      .wxlogo{
        display: inline-block;
        border-radius: 50%;
        border: 1px solid #DFDFDF;
        text-align: center;
        height: 35px;
        width: 35px;
        line-height: 40px;
        cursor: pointer;
        margin-left: 0;
        color: #00bb00;
        svg{
          width: 20px;
          height: 20px;
          color: #00bb00;
        }
      }
        p{
          display: inline-block;
            font-size: 12px;
            color:#bcbcbc;
          margin-top: 5px;
          cursor: pointer;
        }
    }
       .checkbox{
           width: 210px;
       }
       .getVcodeBtn{
           width: 100px;
           display: inline-block;
           background-color: #ed4040;
           margin-left: 10px;
           border-radius: 5px;
           text-align: center;
           color: #ffffff;
           font-size: 12px;
           cursor: pointer;
       }
        .foot_login{
          overflow: hidden;
          text-align: center;
          margin-top: 50px;
          .foot_login_lis{
            display: inline-block;
            height: 30px;
            line-height: 30px;
            a{
              font-size: 14px;
              color: #877463;
              &:hover{
                color: #ed4040;
              }
            }
            span{
              font-size: 14px;
              margin: 0 10px;
              color: #877463;
            }
          }
        }
    .foo_tips{
      text-align: center;
      font-size: 14px;
      color: #9EA0A3;
      background-color: #eee;
      padding: 15px 0;
  }
       .head-contents-txz {
         position:fixed;
         left: 0;
         top: 0;
         width: 100%;
         height: 90px;
         background: #fff;
         box-shadow: 0 0px 5px 0px hsla(0,0%,72%,.5);
       }
       .nav-txz{
         width: 1200px;
         height: 90px;
         margin: 0 auto;
       }
       .nav-txz .logo {
         width:296px;
         height: 57px;
         float: left;
         margin: 24px 0 0 0;
       }
       .nav-txz .nav {
         width: 70%;
         text-align: right;
         float: right;
       }
       .nav-txz .nav a {
         line-height: 90px;
         font-size: 16px;
         padding:15px;
         text-decoration: none;
         color: #5C5C5C;
       }
       .nav-txz .nav a:hover {
         color: #e3003a;
       }
  .contentBox_rightBox{
    display: inline-block;
    width: 460px;
    border-left: 1px solid #EEEEEE;
    height: 380px;
    vertical-align: top;
  }
  .contentBox_leftBox{
    display: inline-block;
    vertical-align: top;
    width: 339px;
    margin: 50px auto;
    text-align: center;
    img{
      width: 200px;
      height: 200px;
    }
  }
  .num{
    background-color: #fff;
    color: #a19d9e;
    cursor: not-allowed;
    span{
      font-size: 12px;
      color: #a19d9e;
    }
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .bgI{
      .contentBox{
        width: 80%;
        margin: 65px auto;
        .denglubtn{
          width: calc( 80vw - 40px );
          margin-left: 0;
        }
      }
    }
    .contentBox_leftBox{
      display: none;
    }
    .contentBox_rightBox{
      width: auto;
    }
    .foo_tips{
      display: none;
    }
    .nav-txz{
      display: none;
    }
    .head-contents-txz{
      height: 65px;
    }
  }
</style>

